// 2 products - 15% Off
// 3 products - 20% Off
// 4 products - 25% Off
// 5 products - 30% Off

function formatCurrency(money) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  })

  return formatter.format(money)
}

const buildABox = {
  settings: {
    step: 1,
    discountMultiplier: 1,
    discountPercentage: 0,
    productsNeeded: 0,
    discountCode: null,
    discounts: [...buildYourBoxDiscountSettings],
    freebiesThreshold: freebieAt || [4, 5],
  },
  Defaults: {
    min: 2,
    getProductCards: function () {
      return document.querySelectorAll(".bundle-list__product")
    },
    counters: function () {
      return document.querySelectorAll("[data-is-product-counter='true']")
    },
    cartContainer: function () {
      return document.querySelector("[data-bab-cart]")
    },
    upsellContainer: function () {
      return document.querySelector("[data-bab-upsell]")
    },
    priceDisplay: function () {
      return document.querySelectorAll("[data-bab-price]")
    },
    comparePriceDisplay: function () {
      return document.querySelectorAll("[data-bab-compare-price]")
    },
    discountBadgeDisplay: function () {
      return document.querySelectorAll("[data-bab-discount-badge]")
    },
  },
  Utils: {
    getStoredCart: function () {
      const storedCart = localStorage.getItem("buildABox-cart")
      return storedCart ? JSON.parse(storedCart) : []
    },
    saveCart: function (newCart) {
      localStorage.setItem("buildABox-cart", JSON.stringify(newCart))
      buildABox.Utils.calculateDiscount()
      buildABox.Utils.updateContent()
    },
    countItems: function () {
      const currentCart = buildABox.Utils.getStoredCart()
      return buildABox.settings.step === 1
        ? currentCart.reduce((count, item) => (!item.isUpsell ? count + 1 : count), 0)
        : currentCart.length
    },
    countForDiscount: function () {
      const cart = buildABox.Utils.getStoredCart()
      return cart.reduce((count, item) => (!item.isUpsell ? count + 1 : count), 0)
    },
    countItemsInCart: function (itemId) {
      const cart = buildABox.Utils.getStoredCart()
      return cart.reduce((count, item) => (item.id === itemId ? count + 1 : count), 0)
    },
    sumTotalPrice: function () {
      const cart = buildABox.Utils.getStoredCart()

      return cart.reduce((acc, item) => {
        if (!item.isUpsell) {
          return acc + item.price
        }

        return acc
      }, 0)
    },
    sumUpsellTotal: function () {
      const cart = buildABox.Utils.getStoredCart()

      return cart.reduce((acc, item) => {
        if (item.isUpsell) {
          return acc + item.price
        }
        return acc
      }, 0)
    },
    calculateDiscount: function () {
      const count = buildABox.Utils.countForDiscount()

      let discountAmount = 1
      let appliedDiscount = null

      for (const discount of buildABox.settings.discounts) {
        if (discount.condition(count)) {
          appliedDiscount = discount.code
          discountAmount = discount.amount
        }
      }

      // NOTE: discount multiplier is a basic math formula where the discount is multiplied by the percentage in a decimal
      /*
      For example:
      price: 100
      discount: 15
      discount multiplier: 100 - 15 / 100 = 0.85
      formula: 100 * 0.85 = 85
       */
      buildABox.settings.discountMultiplier = discountAmount !== 1 ? 1 - discountAmount : 1
      buildABox.settings.discountPercentage = discountAmount
      buildABox.settings.discountCode = appliedDiscount
    },
    handleAddToCart: function ($button) {
      const $item = $button.closest('[data-product-card="true"]')

      const data = {
        id: $item.dataset.productId,
        title: $item.dataset.productTitle,
        price: Number($item.dataset.productPrice),
        image: {
          src: $item.dataset.productImageUrl,
          alt: $item.dataset.productImageAlt,
        },
        isUpsell: $item.dataset.isupsell === "true",
      }

      const currentCart = buildABox.Utils.getStoredCart()
      const newCart = [...currentCart, data]

      buildABox.Utils.saveCart(newCart)
    },
    decreaseItemFromCart: function ($button) {
      const $item = $button.closest('[data-product-card="true"]')
      const id = $item.dataset.productId

      const cart = buildABox.Utils.getStoredCart()
      const index = cart.findIndex((item) => item.id === id)

      if (index !== -1) {
        cart.splice(index, 1) // Remove one element with the target ID
        buildABox.Utils.saveCart(cart)
      }
    },
    handleRemove: function (item) {
      const index = Number(item.dataset.productIndex)
      const newCart = buildABox.Utils.getStoredCart()

      if (index >= 0 && index < newCart.length) {
        newCart.splice(index, 1)
      } else {
        console.log("Invalid index to remove.")
      }

      buildABox.Utils.saveCart(newCart)
    },
    updateContent: function () {
      buildABox.Utils.renderSavedItems()
      buildABox.Utils.updatePrices()
      buildABox.Utils.updateCount()
      buildABox.Utils.updateDiscountDisplay()
      buildABox.Utils.updateProductCards()
      buildABox.Utils.updateUpsellCards()
      buildABox.Utils.hideOnNoDiscount()
      buildABox.Utils.showOnNoDiscount()
      buildABox.Utils.updateCartProductCards()
      buildABox.Freebies.unlock()
      buildABox.Utils.initRemoveButtons()
    },
    updatePrices: function () {
      let totalPrice = buildABox.Utils.sumTotalPrice()
      const upsellPrice = buildABox.Utils.sumUpsellTotal()

      let discountedPrice = totalPrice * buildABox.settings.discountMultiplier

      if (buildABox.settings.step === 2) {
        discountedPrice = discountedPrice + upsellPrice
        totalPrice = totalPrice + upsellPrice
      }

      buildABox.Defaults.priceDisplay().forEach((item) => {
        item.innerText = `${formatCurrency(discountedPrice / 100)}`
      })

      buildABox.Defaults.comparePriceDisplay().forEach((item) => {
        item.innerText = `${formatCurrency(totalPrice / 100)}`
      })
    },
    updateCount: function () {
      const count = buildABox.Utils.countItems()
      document.querySelectorAll('[data-is-product-counter="true"]').forEach((item) => {
        item.innerText = count
      })
    },
    updateDiscountDisplay: function () {
      const discountAmount = buildABox.settings.discountPercentage * 100

      buildABox.Defaults.discountBadgeDisplay().forEach((elm) => {
        elm.innerText = `${discountAmount}% OFF`
      })
    },
    hideOnNoDiscount: function () {
      const count = buildABox.Utils.countItems()
      const hideClass = count < 2 ? "hidden" : ""

      document.querySelectorAll("[data-bab-hide-on-no-discount]").forEach((item) => {
        item.classList.toggle("hidden", hideClass === "hidden")
      })
    },
    showOnNoDiscount: function () {
      const count = buildABox.Utils.countItems()
      const showClass = count < 2 ? "hidden" : ""

      document.querySelectorAll("[data-bab-show-on-no-discount]").forEach((item) => {
        item.classList.toggle("hidden", showClass !== "hidden")
      })
    },
    updateProductCards: function () {
      const itemCards = buildABox.Defaults.getProductCards()
      const discountMultiplier = buildABox.settings.discountMultiplier

      itemCards.forEach((item) => {
        const id = item.dataset.productId
        const price = Number(item.dataset.productPrice) || 0
        const inCartCount = buildABox.Utils.countItemsInCart(id)

        const quantityElement = item.querySelector(".bundle-item__quantity")
        const priceElement = item.querySelector('[data-v-price-display="true"]')
        const comparePriceElement = item.querySelector('[data-v-price-compare="true"]')

        if (!priceElement) {
          console.log("NO PRICE ELEMENT FOUND")
          return
        }

        if (inCartCount !== parseInt(quantityElement.innerText)) {
          quantityElement.innerText = inCartCount || 0
        }

        // If there is a discount update the price
        if (discountMultiplier < 1) {
          const newPrice = price * discountMultiplier
          priceElement.innerText = `${formatCurrency(newPrice / 100)}`
          comparePriceElement.classList.remove("hidden")
        } else {
          priceElement.innerText = `${formatCurrency(price / 100)}`
          comparePriceElement.classList.add("hidden")
        }

        // Checks if item is in cart
        if (inCartCount > 0) {
          item.classList.add("is-on-cart")
        } else {
          item.classList.remove("is-on-cart")
        }
      })
    },
    updateCartProductCards: function () {
      const items = document.querySelectorAll('[data-is-cart-item="true"]')
      const discountMultiplier = buildABox.settings.discountMultiplier

      items.forEach((item) => {
        const priceElement = item.querySelector(".bundle-cart__item-price")
        const comparePriceElement = item.querySelector(".bundle-cart__item-compare-price")
        const price = Number(item.dataset.productPrice) || 0

        // If there is a discount update the price
        if (discountMultiplier < 1) {
          const newPrice = price * discountMultiplier
          priceElement.innerText = `${formatCurrency(newPrice / 100)}`

          comparePriceElement.classList.remove("hidden")
        } else {
          priceElement.innerText = `${formatCurrency(price / 100)}`
          comparePriceElement.classList.add("hidden")
        }
      })
    },
    updateUpsellCards: function () {
      const cards = document.querySelectorAll(".bab-upsell__item")
      cards.forEach((item) => {
        const id = item.dataset.productId
        const inCartCount = buildABox.Utils.countItemsInCart(id)
        const quantityElement = item.querySelector(".bundle-item__quantity")

        quantityElement.innerText = inCartCount || 0

        if (inCartCount > 0) {
          item.classList.add("is-on-cart")
        } else {
          item.classList.remove("is-on-cart")
        }
      })
    },
    renderItemHTML: function (item, index) {
      const price = item.price / 100
      return `
      <div class="bundle-cart__item" data-is-cart-item="true" data-product-price="${item.price}">
        <div class="bundle-cart__item-image">
          <img src="${item.image.src}" alt="${item.image.alt}" />
        </div>
        <div class="bundle-cart__item-content">
          <div class="bundle-cart__item-info">
           <div>${item.title}</div>
          </div>
          <div class="bundle-cart__item-actions">
            <div class="bundle-cart__item-prices">
              <div class="bundle-cart__item-price">${formatCurrency(price)}</div>
              <div class="bundle-cart__item-compare-price">${formatCurrency(price)}</div>
            </div>
            <button data-product-index="${index}" class="bundle-item__remove">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2">
                <path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                <line x1="10" x2="10" y1="11" y2="17"/>
                <line x1="14" x2="14" y1="11" y2="17"/>
              </svg>
              remove
            </button>
          </div>
        </div>
      </div>
      `
    },
    renderSavedItems: function () {
      const carts = document.querySelectorAll(".bundle-cart__items")
      const currentCart = buildABox.Utils.getStoredCart()

      console.log("ITEMS: -> ", currentCart)

      const renderedItems = currentCart
        .filter((item) => !item.isUpsell)
        .map((item, index) => buildABox.Utils.renderItemHTML(item, index))

      carts.forEach((elm) => {
        elm.innerHTML = renderedItems.join("")
      })

      buildABox.UpdateContent.renderStickyHeader()
    },
    initRemoveButtons: function () {
      const buttons = document.querySelectorAll(".bundle-item__remove")
      buttons.forEach((button) => {
        button.addEventListener("click", function () {
          buildABox.Utils.handleRemove(this)
        })
      })
    },
  },
  UpdateContent: {
    emptyItem: function (count, index) {
      let discountMessage = ""

      const discount = buildABox.settings.discounts.find(
        (discountSetting) => discountSetting.productsNeeded === index + 1,
      )

      if (discount) {
        discountMessage = `${discount.amount * 100}% off`
      }

      if (!discount) {
        return `
        <div class="build-a-box__banner-product">
          <div class="build-a-box__banner-product-card empty">
            <div class="build-a-box__banner-message">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-circle">
                <circle cx="12" cy="12" r="10"/>
                <path d="M8 12h8"/>
                <path d="M12 8v8"/>
              </svg>
            </div>
            <div class="build-a-box__banner-product-image image is-square">
            
            </div>
          </div>
        </div>
        `
      }

      return `
        <div class="build-a-box__banner-product">
          <div class="build-a-box__banner-product-card empty">
            <div class="build-a-box__banner-message">${discountMessage}</div>
            <div class="build-a-box__banner-product-image image is-square">
            
            </div>
          </div>
        </div>
      `
    },
    stickyHeaderItem: function (item, index) {
      return `
        <div class="build-a-box__banner-product">
          <div class="build-a-box__banner-product-card">
            <button data-product-index="${index}" class="bundle-item__remove build-a-box__banner-product-remove">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2">
                <path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                <line x1="10" x2="10" y1="11" y2="17"/>
                <line x1="14" x2="14" y1="11" y2="17"/>
              </svg>
            </button>
            <div class="build-a-box__banner-product-image image is-square">
              <img src="${item.image.src}" alt="${item.image.alt}" />
            </div>
          </div>
        </div>
        `
    },
    renderStickyHeader: function () {
      const count = buildABox.Utils.countItems()
      const currentCart = buildABox.Utils.getStoredCart()
      const header = document.querySelector(".build-a-box__banner-products")
      const maxItemsToShow = 6

      const renderedBanner = currentCart.map((item, index) => {
        return buildABox.UpdateContent.stickyHeaderItem(item, index)
      })

      // Add empty states for any remaining slots

      for (let i = currentCart.length; i < maxItemsToShow; i++) {
        renderedBanner.push(buildABox.UpdateContent.emptyItem(count, i))
      }

      header.innerHTML = renderedBanner.join("")
    },
  },
  Freebies: {
    freebiesTemplate(item) {
      const image = item.querySelector("img")

      return `
        <div class="bundle-cart__item-freebie" data-is-cart-item="false" data-product-price="0">
          <div class="bundle-cart__item-image">
          ${image ? image.outerHTML : ""}
          </div>
          <div class="bundle-cart__item-content">
            <div class="bundle-cart__item-info">
             <div>${item.getAttribute("data-product-title")}</div>
             </div>
             <div class="bundle-cart__item-actions">
              <div class="bundle-cart__item-prices">
              <div class="bundle-cart__item-price">FREE</div>
              </div>
              </div>
          </div>
        </div> 
      `
    },
    renderFreebies() {
      const freebies = document.querySelectorAll(".bab-freebie.active")
      const carts = document.querySelectorAll(".bundle-cart__items")

      const renderedList = Array.from(freebies).map((item) => buildABox.Freebies.freebiesTemplate(item))

      carts.forEach((elm) => {
        elm.innerHTML += renderedList.join("")
      })
    },
    unlock() {
      const count = buildABox.Utils.countItems()
      const threshold = buildABox.settings.freebiesThreshold

      const freebies = document.querySelectorAll(".bab-freebie")

      freebies.forEach((item, index) => {
        const currentThreshold = threshold[index]

        if (count >= currentThreshold) {
          item.classList.add("active")
        } else {
          item.classList.remove("active")
        }
      })

      buildABox.Freebies.renderFreebies()
    },
  },
  Upsell: {
    increaseStep: function () {
      buildABox.settings.step = 2
      buildABox.Upsell.handleStepIncrease()
      buildABox.Utils.updateContent()
    },
    decreaseStep: function () {
      buildABox.settings.step = 1
      buildABox.Upsell.handleStepIncrease()
      buildABox.Utils.updateContent()
    },
    handleStepIncrease: function () {
      const step = buildABox.settings.step

      if (step === 2) {
        buildABox.Upsell.handleUpsellStep()
      } else {
        buildABox.Upsell.handleCartStep()
      }
    },
    handleUpsellStep: function () {
      const cart = buildABox.Defaults.cartContainer()
      const upsell = buildABox.Defaults.upsellContainer()

      cart.classList.add("hidden")
      upsell.classList.remove("hidden")
    },
    handleCartStep: function () {
      const cart = buildABox.Defaults.cartContainer()
      const upsell = buildABox.Defaults.upsellContainer()

      cart.classList.remove("hidden")
      upsell.classList.add("hidden")
    },
  },
  Checkout: {
    processAddToCart: function () {
      this.classList.add("loading")
      const items = buildABox.Checkout.generateCart()
      buildABox.Checkout.processToCart(items)
    },
    generateCart: function () {
      const items = buildABox.Utils.getStoredCart()

      const cartItems = items.reduce((result, item) => {
        const existingItem = result.find((i) => i.id === item.id)

        if (existingItem) {
          existingItem.quantity += 1
        } else {
          const newItem = { ...item, quantity: 1 }
          result.push(newItem)
        }

        return result
      }, [])

      let freeItems = []
      const freebies = document.querySelectorAll(".bab-freebie.active")

      freebies.forEach((item) => {
        const id = item.getAttribute("data-product-id")
        if (id) {
          freeItems.push({ id: id, quantity: 1 })
        }
      })

      let permalink = ""

      const combined = cartItems.concat(freeItems)

      combined.forEach((item, index) => {
        permalink += (index > 0 ? "," : "") + `${item.id}:${item.quantity}`
      })

      return permalink
    },
    processToCart: function (itemsLink) {
      localStorage.removeItem("buildABox-cart")
      const url = window.shopUrl + `/cart/` + itemsLink + "?discount=" + buildABox.settings.discountCode
      fetch("/cart/clear.js", { method: "POST" }).then((res) => {
        window.location.href = url
      })
    },
  },
  init: function () {
    const addToCartButtons = document.querySelectorAll('[data-add-to-cart="true"]')
    addToCartButtons.forEach((button) => {
      button.addEventListener("click", function () {
        buildABox.Utils.handleAddToCart(this)
      })
    })

    const decreaseButtons = document.querySelectorAll('[data-decrease-cart="true"]')
    decreaseButtons.forEach((button) => {
      button.addEventListener("click", function () {
        buildABox.Utils.decreaseItemFromCart(this)
      })
    })

    // Next event elements
    const nextElements = document.querySelectorAll("[data-bab-next]")
    nextElements.forEach((elm) => {
      elm.addEventListener("click", buildABox.Upsell.increaseStep)
    })
    // GO back
    document.querySelector(".bab-upsell__back").addEventListener("click", buildABox.Upsell.decreaseStep)

    // Checkout
    document.querySelector("[data-bab-checkout]").addEventListener("click", buildABox.Checkout.processAddToCart)

    buildABox.Utils.calculateDiscount()
    buildABox.Utils.updateContent()
  },
}

buildABox.init()

const babModal = document.querySelector(".bab-modal")
const modalTrigger = document.querySelector(".bab-modal__button")
const modalClose = document.querySelector(".bab-modal__close")

modalClose.addEventListener("click", triggerBabModal)
modalTrigger.addEventListener("click", triggerBabModal)

function triggerBabModal() {
  const isOpen = babModal.dataset.open

  if (isOpen === "true") {
    babModal.setAttribute("data-open", "false")
    modalTrigger.setAttribute("data-open", "false")
  } else {
    babModal.setAttribute("data-open", "true")
    modalTrigger.setAttribute("data-open", "true")
  }
}

// Information Modal
const modal = document.querySelector("#product-info-modal")
const productInformationJson = document.querySelector("#productInformation")
const infoButtons = document.querySelectorAll(".product__info")
infoButtons.forEach((button) => {
  button.addEventListener("click", handleInfoButtonClick)
})

function handleInfoButtonClick() {
  const parsed = JSON.parse(productInformationJson.textContent)
  if (!parsed) {
    return console.log("error parsing data")
  }

  const parentCard = this.closest(".bundle-list__product")
  const id = Number(parentCard.dataset.productId)

  const product = parsed.products.find((prod) => prod.id === id)

  //Elements to replace
  const imageElement = modal.querySelector("[data-info-image]")
  const titleElement = modal.querySelector("[data-info-title]")
  const descriptionElement = modal.querySelector("[data-info-description]")

  imageElement.innerHTML = `
  <img src="${product.image}" alt="" loading="lazy" />
  `
  titleElement.innerText = `${product.title}`
  descriptionElement.innerHTML = product.description

  modal.open()
}
